import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ef01810c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ef01810c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef01810c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef01810c')) {
      api.createRecord('ef01810c', component.options)
    } else {
      api.reload('ef01810c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ef01810c&scoped=true&", function () {
      api.rerender('ef01810c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27y3kBoSJZE1T/JS/comp/GuestBox.vue"
export default component.exports